import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

/**
 * PageHeader — shared header used on Dashboard / History / Reflection.
 * Small uppercase eyebrow (usually the app tagline) + large page title.
 */
export function PageHeader({ eyebrowKey = "app.tagline", titleKey, subtitleKey, testId }) {
  const { t } = useI18n();
  return (
    <header className="pt-4" data-testid={testId}>
      <p className="text-xs uppercase tracking-[0.18em] text-[#E8D8B8]/70">
        {t(eyebrowKey)}
      </p>
      <h1
        className="mt-2 text-3xl sm:text-4xl font-medium leading-tight"
        style={{ letterSpacing: "-0.02em" }}
      >
        {t(titleKey)}
      </h1>
      {subtitleKey ? (
        <p className="mt-2 text-[15px] text-[#CBD5E1]">{t(subtitleKey)}</p>
      ) : null}
    </header>
  );
}
